import { OV_FIELDS } from './ovFields';

export const BC_FIELDS = {
  ...OV_FIELDS,
  AMS: 'AMS',
  ASM_CUT: 'ASM_CUT',
  ASTM: 'ASTM',
  BAR_END_TO_BAR_END: 'BAR_END_TO_BAR_END',
  CDA: 'CDA',
  CHAMFER_BAR_END: 'CHAMFER_BAR_END',
  CHAMFER_BAR_END_COMMENTS: 'CHAMFER_BAR_END_COMMENTS',
  CUSTOMER_REQUESTED_UOM: 'CUSTOMER_REQUESTED_UOM',
  DFARS: 'DFARS',
  DISTRIBUTION_CENTER: 'DISTRIBUTION_CENTER',
  INNER_DIAMETER: 'INNER_DIAMETER',
  INNER_DIAMETER_TOLERANCE: 'INNER_DIAMETER_TOLERANCE',
  LAP_SELECTION: 'LAP_SELECTION',
  LAPPING: 'LAPPING',
  LASER_MARKING: 'LASER_MARKING',
  LASER_MARKING_COMMENTS: 'LASER_MARKING_COMMENTS',
  MATERIAL_HARDNESS: 'MATERIAL_HARDNESS',
  MATERIAL_LENGTH: 'MATERIAL_LENGTH',
  MATERIAL_LENGTH_TOLERANCE: 'MATERIAL_LENGTH_TOLERANCE',
  MATERIAL_LENGTH_TOLERANCE_OPTION: 'MATERIAL_LENGTH_TOLERANCE_OPTION',
  MATERIAL_ROUNDNESS: 'MATERIAL_ROUNDNESS',
  MATERIAL_SIZE: 'MATERIAL_SIZE',
  MATERIAL_SOURCE: 'MATERIAL_SOURCE',
  MATERIAL_STRAIGHTNESS: 'MATERIAL_STRAIGHTNESS',
  MATERIAL_STRAIGHTNESS_UOM: 'MATERIAL_STRAIGHTNESS_UOM',
  MATERIAL_SURFACE_FINISH: 'MATERIAL_SURFACE_FINISH',
  MATERIAL_SURFACE_FINISH_UOM: 'MATERIAL_SURFACE_FINISH_UOM',
  MATERIAL_THICKNESS: 'MATERIAL_THICKNESS',
  MATERIAL_THICKNESS_TOLERANCE: 'MATERIAL_THICKNESS_TOLERANCE',
  MATERIAL_WALL_THICKNESS: 'MATERIAL_WALL_THICKNESS',
  MATERIAL_WIDTH: 'MATERIAL_WIDTH',
  MATERIAL_WIDTH_TOLERANCE: 'MATERIAL_WIDTH_TOLERANCE',
  MIL: 'MIL',
  MVC: 'MVC',
  MVC_SELECTION: 'MVC_SELECTION',
  NUMBER_OF_MANUFACTURING_LOTS: 'NUMBER_OF_MANUFACTURING_LOTS',
  NUMBER_OF_RELEASES: 'NUMBER_OF_RELEASES',
  OUR_TRUCK: 'OUR_TRUCK',
  OUTER_DIAMETER: 'OUTER_DIAMETER',
  OUTER_DIAMETER_TOLERANCE: 'OUTER_DIAMETER_TOLERANCE',
  PACK_MESH: 'PACK_MESH',
  PACK_SLEEVE: 'PACK_SLEEVE',
  PACK_SPECIAL: 'PACK_SPECIAL',
  PACK_TUBE: 'PACK_TUBE',
  PART_UOM: 'PART_UOM',
  PC_IS_BOUGHT: 'PC_IS_BOUGHT',
  PPAP_INSPECTION_REQUIRED: 'PPAP_INSPECTION_REQUIRED',
  PROCESS_NAME: 'PROCESS_NAME',
  PRODUCT_SHAPE: 'PRODUCT_SHAPE',
  ROHS: 'ROHS',
  SAW_CUT: 'SAW_CUT',
  SPECIAL_MATERIAL_SPECS_OR_PROPERTIES: 'SPECIAL_MATERIAL_SPECS_OR_PROPERTIES',
  STARTING_DIAMETER: 'STARTING_DIAMETER',
  QQ: 'QQ',
  XRF_MANUAL: 'XRF_MANUAL',
  QA_TEST_INSTRON: 'QA_TEST_INSTRON',
  QA_TEST_HARD: 'QA_TEST_HARD',
  QA_TEST_HARD_MIC: 'QA_TEST_HARD_MIC',
} as const;
